<div class="overview">
    <div class="overview-navigation">
        <div class="wrapper">
            <ul *ngIf="showTemplatesTab">
                <li
                    routerLink="/overview/quotes"
                    routerLinkActive="active"
                    (click)="selectedTab = 'offers'"
                    [class.active]="selectedTab === 'offers'"
                >
                    {{ 'OVERVIEW.OFFERS.TITLE' | translate }}
                </li>
                <li
                    routerLink="/overview/templates"
                    routerLinkActive="active"
                    (click)="selectedTab = 'templates'"
                    [class.active]="selectedTab === 'templates'"
                >
                    {{ 'OVERVIEW.TEMPLATES.TITLE' | translate }}
                </li>
            </ul>
        </div>
    </div>
    <div class="overview-content">
        <div class="wrapper">
            <div class="content-header">
                <ng-container *ngIf="selectedTab === 'offers'">
                    <div class="header-partner" *ngIf="isEmployee">
                        <app-customer-selection
                            [partnerMode]="true"
                            buttonText="OVERVIEW.BUTTON.PARTNER_MODE"
                            (customerChanged)="onCustomerSelected()"
                        ></app-customer-selection>
                    </div>
                    <div class="header-content">
                        <h2 *ngIf="isPartnerMode">{{ 'OVERVIEW.TITLE_PARTNER_MODE' | translate }}</h2>
                        <h2 *ngIf="!isPartnerMode">{{ 'OVERVIEW.OFFERS.TITLE' | translate }}</h2>
                        <div class="content-toolbar">
                            <a
                                *ngIf="appService.getSalesOrg() === '0500'"
                                mat-stroked-button
                                [href]="foerderProfiUrl"
                                target="_blank"
                                color="primary"
                            >
                                {{ 'OVERVIEW.BUTTON.FOERDER-PROFI' | translate }}
                            </a>
                            <button mat-flat-button color="primary" (click)="createNewOffer()">
                                {{ 'OVERVIEW.BUTTON.CREATE_NEW' | translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="selectedTab === 'templates'">
                    <div class="header-content">
                        <h2>{{ 'OVERVIEW.TEMPLATES.TITLE' | translate }}</h2>
                    </div>
                </ng-container>
            </div>
            <div class="content-table">
                <div class="table-toolbar">
                    <app-search-and-filter
                        (offerSearch)="onSearch($event)"
                        [selectedTab]="selectedTab"
                    ></app-search-and-filter>
                </div>
                <app-loader *ngIf="isLoading" [isLoading]="isLoading" [message]="loaderText"></app-loader>
                <app-overview-table
                    [hidden]="isLoading || selectedTab !== 'offers'"
                    [dataSource]="overviewTableDataSource"
                    [isEmployee]="isEmployee"
                    [isAdmin]="isAdmin"
                    (view)="onViewQuote($event)"
                    (copyQuote)="onCopyQuote($event)"
                    (delete)="onDeleteQuote($event)"
                    (pagingError)="onPagingError()"
                    (sortError)="onSortError()"
                ></app-overview-table>
                <app-templates-table
                    [hidden]="isLoading || selectedTab !== 'templates'"
                    [dataSource]="templatesDataSource"
                    [isAdmin]="isAdmin"
                    (use)="onUseTemplate($event)"
                    (edit)="onEditTemplate($event)"
                    (delete)="onDeleteTemplate($event)"
                    (pagingError)="onPagingError()"
                    (sortError)="onSortError()"
                ></app-templates-table>
            </div>
        </div>
    </div>
</div>
